import { shape, string, any } from "prop-types";

export const file = shape({
	fields: shape({
		title: string,
		description: string,
		file: shape({
			url: string,
			fileName: string,
			contentType: string,
		}),
	}),
});

export const pageProps = shape({
	resources: any, // eslint-disable-line react/forbid-prop-types,
	siteDomain: string.isRequired,
	prefix: string,
	brandCode: string,
	components: any, // eslint-disable-line react/forbid-prop-types,
});
